import { render } from "./ItemListMaterial.vue?vue&type=template&id=1ebda066&scoped=true"
import script from "./ItemListMaterial.vue?vue&type=script&lang=js"
export * from "./ItemListMaterial.vue?vue&type=script&lang=js"

import "./ItemListMaterial.vue?vue&type=style&index=0&id=1ebda066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebda066"]])

export default __exports__